module.exports = __webpack_public_path__ + "static/media/arrow-main-right.b61023a6.svg";